// plan-02 S06: lazy AudioContext — 48 kHz, first-gesture resume — bible S16

let ctx: AudioContext | null = null
let masterGain: GainNode | null = null

export function getCtx(): AudioContext {
  if (!ctx) {
    ctx = new AudioContext({ sampleRate: 48000 })
  }
  return ctx
}

// master gain sits between all audio nodes and the destination
export function getMasterGain(): GainNode {
  const c = getCtx()
  if (!masterGain) {
    masterGain = c.createGain()
    masterGain.connect(c.destination)
  }
  return masterGain
}

export function setMasterMuted(muted: boolean): void {
  const g = getMasterGain()
  g.gain.setValueAtTime(muted ? 0 : 1, g.context.currentTime)
}

export async function resumeOnGesture(): Promise<void> {
  const c = getCtx()
  if (c.state === 'suspended') {
    await c.resume()
  }
}
